import { ISnapLineStyleSheet } from '@src/slide/application/service/snap-line-service/interface/render.interface';

export const pcSnapLineStyleSheet: ISnapLineStyleSheet = {
    strokeWidth: 1,
    strokeDash: 3.5,
    margin: {
        arrowSize: { width: 7, height: 7 },
        displayPadding: 15,
    },
    edge: {
        displayPadding: 10,
    },
    rect: {},
};

export const mobileSnapLineStyleSheet: ISnapLineStyleSheet = {
    strokeWidth: 1.25,
    strokeDash: 3,
    margin: {
        arrowSize: { width: 5, height: 5 },
        displayPadding: 15,
    },
    edge: {
        displayPadding: 10,
    },
    rect: {},
};
